import { useQuery } from '@tanstack/react-query';
import { useMemo } from 'react';
import { terraProxyApiClient } from '../../clients/testerClient';

type UseCredentialsProps = {
  applicationId?: string;
};

type Credential = {
  id: string;
  username?: string;
  role?: string;
};

export function useCredentials({ applicationId }: UseCredentialsProps): {
  credentials: Credential[];
} {
  const query = useQuery({
    queryKey: ['credentials-preview', applicationId],
    queryFn: async (): Promise<Credential[]> => {
      if (!applicationId) {
        return [];
      }

      const result =
        await terraProxyApiClient.getCredentialsPreview(applicationId);

      return result?.credentials || [];
    },
    enabled: !!applicationId,
    staleTime: 30000,
  });

  const credentials = useMemo(() => query.data ?? [], [query.data]);

  return { credentials };
}
